import React from "react";
import PropTypes from "prop-types";
import TruncatedText from "../../../../components/TruncatedText/TruncatedText";
import { truncateHgvs } from "../../../../components/TruncatedText/helpers";

const Hgvs = ({ isFLT3ITD, hgvs }) => {
  if (!hgvs) return <span>-</span>;

  const originalResult = hgvs;
  const truncatedResult = truncateHgvs(hgvs);
  if (isFLT3ITD && truncatedResult !== originalResult) {
    return (
      <TruncatedText
        truncatedText={truncatedResult}
        originalText={originalResult}
      />
    );
  }
  return originalResult;
};

Hgvs.propTypes = {
  isFLT3ITD: PropTypes.bool.isRequired,
  hgvs: PropTypes.string,
};

Hgvs.defaultProps = {
  hgvs: null,
};

export default React.memo(Hgvs);
